<template>
    <div class="upload-folder-wrap">
      <div @click="launchFile()">
        <slot name="activator"></slot>
      </div>
      <div v-if="$scopedSlots['activator-camera']" @click="launchCamera()">
        <slot name="activator-camera"></slot>
      </div>
  
      <input
        type="file"
        accept="image/png, image/gif, image/jpg, image/jpeg"
        ref="file"
        :name="filename"
        v-on:change="changeImage($event.target.files, $event.target)"
        style="display:none">
  
      <!-- Dialog kamera: preview live + tombol ambil foto -->
      <v-dialog
        v-model="cameraDialog"
        max-width="500"
        persistent
        @keydown.esc="closeCameraDialog"
        @click:outside="closeCameraDialog">
        <v-card>
          <v-card-title class="teal darken-2 white--text">
            <v-icon left color="white">mdi-camera</v-icon>
            Ambil foto
          </v-card-title>
          <v-card-text class="pa-3">
            <div class="camera-preview-wrap">
              <video
                ref="cameraVideo"
                autoplay
                playsinline
                muted
                class="camera-video">
              </video>
              <div v-if="cameraError" class="camera-error">
                <v-icon size="48" color="grey">mdi-camera-off</v-icon>
                <p>{{ cameraError }}</p>
              </div>
              <div v-if="cameraLoading" class="camera-loading">
                <v-progress-circular indeterminate color="white" size="40"></v-progress-circular>
                <span>Membuka kamera...</span>
              </div>
              <v-btn
                v-if="!cameraError && !cameraLoading && cameraStream"
                icon
                dark
                class="camera-switch-btn"
                @click="switchCamera">
                <v-icon>mdi-camera-switch</v-icon>
              </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pa-3 pt-0">
            <v-spacer></v-spacer>
            <v-btn text @click="closeCameraDialog">Batal</v-btn>
            <v-btn
              color="teal darken-2"
              class="white--text"
              :disabled="!!cameraError || cameraLoading"
              @click="captureFromCamera">
              <v-icon left>mdi-camera-iris</v-icon>
              Ambil foto
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog 
        v-model="dialog"
        width="500">
        <v-card
          class="pa-0 ma-0"
          flat>
          <v-card
            color="red accent-2">
            <v-list-item>
              <v-list-item-avatar 
                color="red accent-2" 
                size="30">
                <v-icon color="white" large>mdi-alert</v-icon>
              </v-list-item-avatar>
              
              <v-list-item-content>
                <v-card-text 
                  class="caption white--text pa-0">
                  {{ message.error }}
                </v-card-text>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
    export default {
      name: 'upload-folder',
      data: () => ({
        dialog: false,
        filename: 'file',
        message: {
          success: '',
          error: ''
        },
        process: {
          form: false
        },
        cameraDialog: false,
        cameraLoading: false,
        cameraError: null,
        cameraStream: null,
        cameraFacing: 'environment' // 'environment' = belakang, 'user' = depan
      }),
      methods: {
        launchFile () {
          this.$refs.file.click()
        },
        launchCamera () {
          if (!this.$scopedSlots['activator-camera']) return
          this.cameraError = null
          this.cameraDialog = true
          this.$nextTick(() => this.startCamera())
        },
        startCamera () {
          if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            this.cameraError = 'Kamera tidak didukung di perangkat ini.'
            return
          }
          if (this.cameraStream) {
            this.cameraStream.getTracks().forEach(t => t.stop())
            this.cameraStream = null
          }
          const video = this.$refs.cameraVideo
          if (video) video.srcObject = null
          this.cameraLoading = true
          this.cameraError = null
          navigator.mediaDevices.getUserMedia({
            video: { facingMode: this.cameraFacing },
            audio: false
          })
            .then(stream => {
              this.cameraStream = stream
              const video = this.$refs.cameraVideo
              if (video) {
                video.srcObject = stream
                video.onloadedmetadata = () => video.play().catch(() => {})
              }
              this.cameraLoading = false
            })
            .catch(err => {
              this.cameraLoading = false
              this.cameraError = err.name === 'NotAllowedError'
                ? 'Akses kamera ditolak. Izinkan kamera di pengaturan browser.'
                : 'Tidak dapat mengakses kamera.'
            })
        },
        closeCameraDialog () {
          this.cameraDialog = false
          if (this.cameraStream) {
            this.cameraStream.getTracks().forEach(t => t.stop())
            this.cameraStream = null
          }
          const video = this.$refs.cameraVideo
          if (video) video.srcObject = null
          this.cameraError = null
          this.cameraFacing = 'environment'
        },
        switchCamera () {
          this.cameraFacing = this.cameraFacing === 'environment' ? 'user' : 'environment'
          this.startCamera()
        },
        captureFromCamera () {
          const video = this.$refs.cameraVideo
          if (!video || !video.srcObject || video.readyState < 2) return
          const canvas = document.createElement('canvas')
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight
          const ctx = canvas.getContext('2d')
          ctx.drawImage(video, 0, 0)
          canvas.toBlob(blob => {
            if (!blob) return
            const file = new File([blob], 'camera.jpg', { type: 'image/jpeg' })
            this.closeCameraDialog()
            this.uploadFile(file)
          }, 'image/jpeg', 0.9)
        },
        changeImage (file, inputEl) {
          const image = file && file[0]
          if (!image) return
          if (image.type !== 'image/jpg' && image.type !== 'image/jpeg' && image.type !== 'image/png' && image.type !== 'image/gif') {
            this.dialog = true
            this.message.error = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png / .gif'
            return
          }
          if (image.size > 5242880) {
            this.dialog = true
            this.message.error = 'Maksimal gambar 5MB'
            return
          }
          this.uploadFile(image, inputEl)
        },
        uploadFile (imageFile, inputEl) {
          const formData = new FormData()
          formData.append('key', 'image')
          formData.append('image', imageFile)
  
          this.process.form = true
          this.$emit('input', { process: this.process.form })
  
          fetch(`${process.env.VUE_APP_API_CDN}image.php`, {
            method: 'POST',
            body: formData
          })
            .then(res => res.json())
            .then(response => {
              this.process.form = false
              if (inputEl) inputEl.value = ''
              this.$emit('input', {
                filename: response.data.filename,
                filepath: response.data.filepath,
                fileuri: response.data.fileuri,
                process: this.process.form
              })
            })
            .catch(() => {
              this.process.form = false
              this.dialog = true
              this.message.error = 'Gagal mengupload gambar.'
            })
        }
      }
    }
  </script>
  
  <style scoped>
  .upload-folder-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .upload-folder-wrap > div {
    flex: 1;
    min-width: 160px;
  }
  .camera-preview-wrap {
    position: relative;
    width: 100%;
    background: #000;
    border-radius: 8px;
    overflow: hidden;
    min-height: 350px;
  }
  .camera-video {
    width: 100%;
    display: block;
    max-height: 80vh;
    height: 70vh;
  }
  .camera-loading,
  .camera-error {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
  }
  .camera-error p {
    margin: 0;
    font-size: 14px;
    text-align: center;
    padding: 0 16px;
  }
  .camera-switch-btn {
    position: absolute;
    bottom: 12px;
    right: 12px;
    background: rgba(0, 0, 0, 0.5) !important;
  }
  .camera-switch-btn:hover {
    background: rgba(0, 0, 0, 0.7) !important;
  }
  </style>